'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function JMFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-oi8a3ltwz", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-oi8a3ltwz)" }, /* @__PURE__ */ React.createElement("path", { fill: "#093", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("g", { fill: "#272727", stroke: "#feca00", strokeWidth: "2.7" }, /* @__PURE__ */ React.createElement("path", { d: "M-2.35-2.865L15.658 12-2.35 26.865z" }), /* @__PURE__ */ React.createElement("path", { d: "M34.35-2.784L15.6 12l18.75 14.784z" }))))
  );
}

export { JMFlag };
//# sourceMappingURL=JM.mjs.map
